import { Content } from '@app/models/Content';
import { Injectable } from "@angular/core";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ContentApi extends HOAApiBase {

    constructor() {
        super('ContentApi');
    }

    /*
     * Get the current global content by type
     */
    public fetchGlobalContentByLocationType(locationType: String): Observable<Content> {
        return this.http.get<Content>(this.createUrl('HOAPass', `/content/type/${locationType}/current`));
    }

    /*
     * Get the current logo for pmc
     */
    public fetchCurrentLogoForPmc(pmcCouponId?: String): Observable<Content> {
        return this.http.get<Content>(this.createUrl('HOAPass', `/content/coupon/${pmcCouponId}/type/pmclogo/current`));
    }

}

